// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__sOK9d","footerLinks":"style_footerLinks__hfnJ5"};